module.exports = __webpack_public_path__ + "img/40_38_028_190.464f4283.jpg";